import { styled } from "styled-components";
const FieldsetImpl = styled("fieldset")(({ theme }) => ({
  border: 0,
  color: theme.color.default,
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  margin: 0,
  padding: 0
}));
const FieldsetLegend = styled("legend")({
  marginBottom: 4,
  padding: 0
});
export {
  FieldsetImpl,
  FieldsetLegend
};
